<template>
  <div class="first-allocation">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card class="box-card custom-header" shadow="never">
          <div slot="header" class="clearfix"><el-button type="primary" @click="openDrawer('formTab')">添加接线图页签</el-button></div>
          <el-table class="tbl" @row-click="clickTabRow" :data="tableTabData" border height="234" :highlight-current-row="true">
            <el-table-column type="index" label="页签编号" width="100" align="center"></el-table-column>
            <el-table-column prop="tabName" label="页签名称" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.tabName }}
              </template>
            </el-table-column>
            <el-table-column prop="tabContent" label="页签内容" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.tabContent }}
              </template>
            </el-table-column>
            <el-table-column prop="tabType" label="页签类型" width="200">
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.tabType, tabOptions, 'id', 'name') }}
              </template>
            </el-table-column>
            <el-table-column prop="projectId" label="所属项目" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.projectId, projectOptions, 'projectId', 'projectName') }}
              </template>
            </el-table-column>
            <el-table-column prop="isShow" label="是否显示" width="100" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.isShow, isNoOptions, 'value', 'label') }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="openDrawer('formTab', row)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card custom-header" shadow="never">
          <div slot="header" class="clearfix">
            <el-button :disabled="!currentSelectTab" type="primary" @click="openDrawer('formTemplate')">添加模板</el-button>
            <el-button class="cache-btn" size="mini" @click="clearCache" type="danger">清理缓存</el-button>
            </div>
          <el-table class="tbl" @row-click="clickTemplateRow" :data="tableTemplateData" border height="234" :highlight-current-row="true">
            <el-table-column prop="id" width="100" align="center" label="模板编号">
              <template slot-scope="{ row }">
                {{ row.id }}
              </template>
            </el-table-column>
            <el-table-column prop="templateName" label="模板名称" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.templateName }}
              </template>
            </el-table-column>
            <el-table-column prop="projectId" label="所属项目" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.projectId, projectOptions, 'projectId', 'projectName') }}
              </template>
            </el-table-column>
            <el-table-column prop="showType" label="模板展示界面" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.showType, templateInterfaceOptions, 'id', 'name') }}
              </template>
            </el-table-column>
            <el-table-column prop="tabId" label="所属标签" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.tabId, tableTabData, 'id', 'tabName') }}
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="openDrawer('formTemplate', row)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card class="box-card custom-header" shadow="never">
          <div slot="header" class="clearfix"><el-button :disabled="!currentSelectTemplate" type="primary" @click="openDrawer('formDevice')">添加设备</el-button></div>
          <el-table class="tbl" @row-click="clickDeviceRow" :data="tableDeviceData" border :highlight-current-row="true" height="234">
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="infoName" label="设备实体" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.infoName }}
              </template>
            </el-table-column>
            <el-table-column prop="equipName" label="设备名称" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.equipName }}
              </template>
            </el-table-column>
            <el-table-column prop="nameType" label="名称展示类型" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.nameType, devNameTypeOptions, 'id', 'name') }}
              </template>
            </el-table-column>
            <el-table-column prop="image" label="设备图标" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.image }}
              </template>
            </el-table-column>
            <el-table-column prop="imageSizes" label="图标尺寸" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.imageSizes }}
              </template>
            </el-table-column>
            <el-table-column prop="positionType" label="定位类型" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.positionType, positionTypeOptions, 'id', 'name') }}
              </template>
            </el-table-column>
            <el-table-column prop="lineUp" label="设备上线" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.lineUp }}
              </template>
            </el-table-column>
            <el-table-column prop="lineDown" label="设备下线" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.infoName }}
              </template>
            </el-table-column>
            <el-table-column prop="level" label="层级" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.level }}
              </template>
            </el-table-column>
            <el-table-column prop="groupSizes" label="组件尺寸" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.infoName }}
              </template>
            </el-table-column>
            <el-table-column prop="button" label="按钮" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.button }}
              </template>
            </el-table-column>
            <el-table-column prop="parentId" label="父级id" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.parentId, tableTabData, 'id', 'tabName') }}
              </template>
            </el-table-column>
            <el-table-column prop="includeVo" label="包含信息" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.includeVo }}
              </template>
            </el-table-column>
            <el-table-column prop="showOrder" label="显示顺序" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.showOrder }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="openDrawer('formDevice', row)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card custom-header" shadow="never">
          <div slot="header" class="clearfix"><el-button :disabled="!currentSelectDevice" type="primary" @click="openDrawer('formData')">添加数据点</el-button></div>
          <el-table class="tbl" @row-click="clickDataPointRow" :data="tableDeviceDataPoint" border height="234" :highlight-current-row="true">
            <el-table-column prop="infoName" label="数据点实体名称" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.infoName }}
              </template>
            </el-table-column>
            <el-table-column prop="infoId" label="数据点实体" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.infoId, infoIdChildOptions, 'fieldsId', 'content') }}
              </template>
            </el-table-column>
            <el-table-column prop="equipLogicId" label="设备关系表Id" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.equipLogicId }}
              </template>
            </el-table-column>
            <el-table-column prop="equipLogicName" label="设备关系名称" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.equipLogicName }}
              </template>
            </el-table-column>
            <el-table-column prop="fieldsName" label="数据点名称" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.fieldsName }}
              </template>
            </el-table-column>
            <el-table-column prop="color" label="数据点颜色" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.color }}
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="描述" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.desc }}
              </template>
            </el-table-column>
            <el-table-column prop="image" label="数据点图标" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.image }}
              </template>
            </el-table-column>
            <el-table-column prop="nameType" label="名称展示类型" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.nameType, dataNameTypeOptions, 'id', 'name') }}
              </template>
            </el-table-column>
            <el-table-column prop="position" label="字段定位" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.position, positionOptions, 'id', 'name') }}
              </template>
            </el-table-column>
            <el-table-column prop="showOrder" label="显示顺序" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.showOrder }}
              </template>
            </el-table-column>
            <el-table-column prop="imageSizes" label="图标尺寸" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.imageSizes }}
              </template>
            </el-table-column>
            <el-table-column prop="style" label="字段样式" width="200" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.style, styleOptions, 'id', 'name') }}
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="openDrawer('formData', row)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-drawer
      :title="drawerTitle"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :wrapperClosable="false"
      :visible.sync="drawer"
      direction="rtl"
      size="40%"
      :before-close="onCancel"
      :append-to-body="true"
      class="form-drawer"
    >
      <el-card shadow="never" style="margin:0px 20px;">
        <div>
          <el-form ref="formTab" :inline="false" :model="formTab" :rules="ruleTab" label-width="100px" v-if="currentEdit == 'formTab'">
            <el-form-item v-for="(item, index) in formInfo['formTab']" :key="index" :label="item.label" :prop="item.prop">
              <el-input v-if="item.type == 'input'" v-model="formTab[item.prop]"></el-input>
              <el-select v-if="item.type == 'select'" v-model="formTab[item.prop]" style="width:100%">
                <el-option v-show="item.options == 'tabOptions'" v-for="it in tabOptions" :key="it[item.value]" :label="it[item.name]" :value="it[item.value]"></el-option>
                <el-option v-show="item.options == 'projectOptions'" v-for="it in projectOptions" :key="it[item.value]" :label="it[item.name]" :value="it[item.value]"></el-option>
                <el-option v-show="item.options == 'isNoOptions'" v-for="it in isNoOptions" :key="it[item.value]" :label="it[item.name]" :value="it[item.value]"></el-option>
              </el-select>
            </el-form-item>
            <el-row type="flex" class="row-bg" justify="space-around" :gutter="20" v-show="!formTab.id" style="margin-top:40px">
              <el-col :span="6" style="margin-left: 80px;"><el-button class="btn" @click="onCancel">取消</el-button></el-col>
              <el-col :span="6"><el-button class="btn" @click="onReset">重置</el-button></el-col>
              <el-col :span="6"><el-button class="btn" :loading="loading" type="primary" @click="onSave">保存</el-button></el-col>
              <el-col :span="6"><el-button type="primary" :loading="loading" @click="onSaveAnd">保存并继续</el-button></el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="space-around" :gutter="20" v-show="formTab.id" style="margin-top:40px">
              <el-col :span="6" style="margin-left: 80px;"></el-col>
              <el-col :span="6"><el-button class="btn" @click="onCancel">取消</el-button></el-col>
              <el-col :span="6"><el-button class="btn" :loading="loading" type="primary" @click="onSave">保存</el-button></el-col>
              <el-col :span="6"></el-col>
            </el-row>
          </el-form>
          <el-form ref="formTemplate" :inline="false" :model="formTemplate" :rules="ruleTemplate" label-width="120px" v-if="currentEdit == 'formTemplate'">
            <el-form-item v-for="(item, index) in formInfo['formTemplate']" :key="index" :label="item.label" :prop="item.prop">
              <el-input v-if="item.type == 'input'" v-model="formTemplate[item.prop]"></el-input>
              <el-select v-if="item.type == 'select'" v-model="formTemplate[item.prop]" style="width:100%">
                <el-option
                  v-show="item.options == 'templateInterfaceOptions'"
                  v-for="it in templateInterfaceOptions"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-row type="flex" class="row-bg" justify="space-around" :gutter="20" v-show="!formTemplate.id" style="margin-top:40px">
              <el-col :span="6" style="margin-left: 100px;"><el-button class="btn" @click="onCancel">取消</el-button></el-col>
              <el-col :span="6"><el-button class="btn" @click="onReset">重置</el-button></el-col>
              <el-col :span="6"><el-button class="btn" :loading="loading" type="primary" @click="onSave">保存</el-button></el-col>
              <el-col :span="6"><el-button type="primary" :loading="loading" @click="onSaveAnd">保存并继续</el-button></el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="space-around" :gutter="20" v-show="formTemplate.id" style="margin-top:40px">
              <el-col :span="6" style="margin-left: 80px;"></el-col>
              <el-col :span="6"><el-button class="btn" @click="onCancel">取消</el-button></el-col>
              <el-col :span="6"><el-button class="btn" :loading="loading" type="primary" @click="onSave">保存</el-button></el-col>
              <el-col :span="6"></el-col>
            </el-row>
          </el-form>
          <el-form ref="formDevice" :inline="false" :model="formDevice" :rules="ruleDevice" label-width="120px" v-if="currentEdit == 'formDevice'">
            <el-form-item v-for="(item, index) in formInfo['formDevice']" :key="index" :label="item.label" :prop="item.prop">
              <el-input v-if="item.type == 'input'" v-model="formDevice[item.prop]"></el-input>
              <el-select v-if="item.type == 'select'" v-model="formDevice[item.prop]" style="width:100%">
                <el-option
                  v-show="item.options === 'devNameTypeOptions'"
                  v-for="it in devNameTypeOptions"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
                <el-option
                  v-show="item.options === 'dataNameTypeOptions'"
                  v-for="it in dataNameTypeOptions"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
                <el-option
                  v-show="item.options === 'positionTypeOptions'"
                  v-for="it in positionTypeOptions"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
                <el-option
                  v-show="item.options === 'infoIdOptions'"
                  v-for="it in infoIdOptions"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
                <el-option
                  v-show="item.options === 'tableTabData'"
                  v-for="it in tableTabData"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
                <el-option
                  v-show="item.options === 'tableDeviceDataOptions'"
                  v-for="it in tableDeviceDataOptions"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-row type="flex" class="row-bg" justify="space-around" :gutter="20" v-show="!formDevice.id" style="margin-top:40px">
              <el-col :span="6" style="margin-left: 120px;"><el-button class="btn" @click="onCancel">取消</el-button></el-col>
              <el-col :span="6"><el-button class="btn" @click="onReset">重置</el-button></el-col>
              <el-col :span="6"><el-button class="btn" :loading="loading" type="primary" @click="onSave">保存</el-button></el-col>
              <el-col :span="6"><el-button type="primary" :loading="loading" @click="onSaveAnd">保存并继续</el-button></el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="space-around" :gutter="20" v-show="formDevice.id" style="margin-top:40px">
              <el-col :span="6" style="margin-left: 80px;"></el-col>
              <el-col :span="6"><el-button class="btn" @click="onCancel">取消</el-button></el-col>
              <el-col :span="6"><el-button class="btn" :loading="loading" type="primary" @click="onSave">保存</el-button></el-col>
              <el-col :span="6"></el-col>
            </el-row>
          </el-form>
          <el-form ref="formData" :inline="false" :model="formData" :rules="ruleData" label-width="120px" v-if="currentEdit == 'formData'">
            <el-form-item key="first" label="设备实体">
            <el-select v-model="deviceModel" style="width:100%" @change="searchProjectEquipmentFieldsInfo" filterable>
              <el-option
                v-for="item in infoIdOptions"
                :key="item.equipId"
                :label="item.content"
                :value="item.equipId"
              ></el-option>
            </el-select>
            </el-form-item>
            <el-form-item v-for="(item, index) in formInfo['formData']" :key="index" :label="item.label" :prop="item.prop">
              <el-input v-if="item.type == 'input'" v-model="formData[item.prop]"></el-input>
              <el-select v-if="item.type == 'select'" v-model="formData[item.prop]" style="width:100%" filterable>
                <el-option
                  v-show="item.options == 'infoIdChildOptions'"
                  v-for="it in infoIdChildOptions"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
                <el-option
                  v-show="item.options == 'devNameTypeOptions'"
                  v-for="it in devNameTypeOptions"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
                <el-option
                  v-show="item.options == 'dataNameTypeOptions'"
                  v-for="it in dataNameTypeOptions"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
                <el-option
                  v-show="item.options == 'positionOptions'"
                  v-for="it in positionOptions"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
                <el-option
                  v-show="item.options == 'styleOptions'"
                  v-for="it in styleOptions"
                  :key="it[item.value]"
                  :label="it[item.name]"
                  :value="it[item.value]"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-row type="flex" class="row-bg" justify="space-around" :gutter="20" v-show="!formData.id" style="margin-top:40px">
              <el-col :span="6" style="margin-left: 120px;"><el-button class="btn" @click="onCancel">取消</el-button></el-col>
              <el-col :span="6"><el-button class="btn" @click="onReset">重置</el-button></el-col>
              <el-col :span="6"><el-button class="btn" :loading="loading" type="primary" @click="onSave">保存</el-button></el-col>
              <el-col :span="6"><el-button type="primary" :loading="loading" @click="onSaveAnd">保存并继续</el-button></el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="space-around" :gutter="20" v-show="formData.id" style="margin-top:40px">
              <el-col :span="6" style="margin-left: 80px;"></el-col>
              <el-col :span="6"><el-button class="btn" @click="onCancel">取消</el-button></el-col>
              <el-col :span="6"><el-button class="btn" :loading="loading" type="primary" @click="onSave">保存</el-button></el-col>
              <el-col :span="6"></el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </el-drawer>
  </div>
</template>

<script>
import GROUPAPI from '@/api/group';
import PROJECTAPI from '@/api/project';
export default {
  props:{
    projectName:{
      type:[String,Number]
    },
    projectId:{
      type:[String,Number]
    }
  },
  data() {
    return {
      loading: false,
      deviceModel:'',//绑定设备
      tableTabData: [], //页签列表
      tableDeviceDataOptions: [], //设备列表options
      tableDeviceData: [], //设备列表
      tableDeviceDataPoint: [], //数据点列表
      tableTemplateData: [], //模板列表
      formTab: {}, //设备表单formTemplate: {},
      formDevice: {}, //设备数据
      formData: {}, //数据表表单
      formTemplate:{},
      ruleTab: {
        tabName: [{ required: true, message: '数据必填', trigger: 'blur' }],
        tabContent: [{ required: true, message: '数据必填', trigger: 'blur' }],
        tabType: [{ required: true, message: '数据必填', trigger: 'blur' }],
        projectId: [{ required: true, message: '数据必填', trigger: 'blur' }],
        showOrder: [{ required: true, message: '数据必填', trigger: 'blur' }],
        isShow: [{ required: true, message: '数据必填', trigger: 'blur' }]
      },
      ruleTemplate: {
        templateName: [{ required: true, message: '数据必填', trigger: 'blur' }],
        showType: [{ required: true, message: '数据必填', trigger: 'blur' }]
      },
      ruleDevice: {
        // button: [{ required: true, message: '数据必填', trigger: 'blur' }],
        equipName: [{ required: true, message: '数据必填', trigger: 'blur' }],
        // groupSizes: [{ required: true, message: '数据必填', trigger: 'blur' }],
        // image: [{ required: true, message: '数据必填', trigger: 'blur' }],
        // includeVo: [{ required: true, message: '数据必填', trigger: 'blur' }],
        infoId: [{ required: true, message: '数据必填', trigger: 'blur' }],
        level: [{ required: true, message: '数据必填', trigger: 'blur' }],
        // lineDown: [{ required: true, message: '数据必填', trigger: 'blur' }],
        // lineUp: [{ required: true, message: '数据必填', trigger: 'blur' }],
        nameType: [{ required: true, message: '数据必填', trigger: 'blur' }],
        parentId: [{ required: true, message: '数据必填', trigger: 'blur' }],
        positionType: [{ required: true, message: '数据必填', trigger: 'blur' }],
        showOrder: [{ required: true, message: '数据必填', trigger: 'blur' }],
        imageSizes: [{ required: true, message: '数据必填', trigger: 'blur' }],
        templateId: [{ required: true, message: '数据必填', trigger: 'blur' }]
      },
      ruleData: {
        // color: [{ required: true, message: '数据必填', trigger: 'blur' }],
        // desc: [{ required: true, message: '数据必填', trigger: 'blur' }],
        equipLogicId: [{ required: true, message: '数据必填', trigger: 'blur' }],
        fieldsName: [{ required: true, message: '数据必填', trigger: 'blur' }],
        // image: [{ required: true, message: '数据必填', trigger: 'blur' }],
        infoId: [{ required: true, message: '数据必填', trigger: 'blur' }],
        nameType: [{ required: true, message: '数据必填', trigger: 'blur' }],
        position: [{ required: true, message: '数据必填', trigger: 'blur' }],
        showOrder: [{ required: true, message: '数据必填', trigger: 'blur' }],
        style: [{ required: true, message: '数据必填', trigger: 'blur' }]
      },
      currentSelectTab: '', //当前选中的页签
      currentSelectTemplate: '', //当前选中的模板
      currentSelectDevice: '', //当前选中的device
      currentSelectData: '', //当前选中的数据点
      currentEdit: '', //当前编辑标记
      currentRef: '', //当前的ref
      drawerTitle: '', //标题
      drawer: false, //抽屉状态
      tabOptions: [], //页签选项，码表
      projectOptions: [], //项目选项，码表
      templateInterfaceOptions: [], //模板展示界面
      nameTypeOptions: [], //名称展示类型
      positionTypeOptions: [], //设备定位类型
      infoIdOptions:[],//项目下的所有实体
      infoIdChildOptions:[],//数据点实体选项
      isNoOptions: [{ label: '否', value: 0 }, { label: '是', value: 1 }], //是否选项，码表
      styleOptions:[],//字段样式
      positionOptions:[],//数据点定位类型
      formInfo: {
        formTab: [
          { type: 'input', label: '页签名称', prop: 'tabName' },
          { type: 'input', label: '页签内容', prop: 'tabContent' },
          { type: 'select', label: '页签类型', prop: 'tabType', options: 'tabOptions', value: 'id', name: 'name' },
          { type: 'select', label: '所属项目', prop: 'projectId', options: 'projectOptions', value: 'projectId', name: 'projectName' },
          { type: 'input', label: '显示顺序', prop: 'showOrder' },
          { type: 'select', label: '是否显示', prop: 'isShow', options: 'isNoOptions', value: 'value', name: 'label' }
        ],
        formTemplate: [
          { type: 'input', label: '模板名称', prop: 'templateName' },
          { type: 'select', label: '模板展示界面', prop: 'showType', options: 'templateInterfaceOptions', value: 'id', name: 'name' }
        ],
        formDevice: [
          { type: 'input', label: '设备名称', prop: 'equipName' },
          { type: 'input', label: '按钮', prop: 'button' },
          { type: 'input', label: '	组件尺寸', prop: 'groupSizes' },
          { type: 'input', label: '设备图标', prop: 'image' },
          { type: 'input', label: '	包含信息', prop: 'includeVo' },
          { type: 'select', label: '设备实体Id', prop: 'infoId' ,options: 'infoIdOptions', value: 'equipId', name: 'content' },
          { type: 'input', label: '层级', prop: 'level' },
          { type: 'input', label: '设备下线', prop: 'lineDown' },
          { type: 'input', label: '设备上线', prop: 'lineUp' },
          { type: 'select', label: '名称展示类型', prop: 'nameType', options: 'devNameTypeOptions', value: 'id', name: 'name' },
          { type: 'select', label: '父级ID', prop: 'parentId' , options: 'tableDeviceDataOptions', value: 'id', name: 'equipName' },
          { type: 'select', label: '设备定位类型', prop: 'positionType', options: 'positionTypeOptions', value: 'id', name: 'name' },
          { type: 'input', label: '显示顺序', prop: 'showOrder' },
          { type: 'input', label: '图标尺寸', prop: 'imageSizes' }
          // { type: 'input', label: '模板ID', prop: 'templateId' }
        ],
        formData: [
          { type: 'select', label: '数据点实体', prop: 'infoId' , options: 'infoIdChildOptions', value: 'fieldsId', name: 'content'},
          { type: 'input', label: '数据点名称', prop: 'fieldsName' },
          { type: 'select', label: '名称展示类型', prop: 'nameType', options: 'dataNameTypeOptions', value: 'id', name: 'name' },
          { type: 'input', label: '数据点颜色', prop: 'color' },
          { type: 'input', label: '描述', prop: 'desc' },
          { type: 'input', label: '数据点图标', prop: 'image' },
          { type: 'select', label: '字段定位', prop: 'position' , options: 'positionOptions', value: 'id', name: 'name' },
          { type: 'input', label: '显示顺序', prop: 'showOrder' },
          { type: 'input', label: '图标尺寸', prop: 'imageSizes' },
          { type: 'select', label: '字段样式', prop: 'style' , options: 'styleOptions', value: 'id', name: 'name'}
        ]
      }
    };
  },
  created() {
    //获取页签码表
    this.searchCodes(11, 'tabOptions');
    //模板显示界面
    this.searchCodes(18, 'templateInterfaceOptions');
    //设备名称展示类型-数据点
    this.searchCodes(20, 'dataNameTypeOptions');
    //设备名称展示类型-设备
    this.searchCodes(19, 'devNameTypeOptions');
    //设备定位类型
    this.searchCodes(21, 'positionTypeOptions');
    //设备数据点定位类型
    this.searchCodes(22, 'positionOptions');
    //设备数据点样式
    this.searchCodes(23, 'styleOptions');
    //查询项目列表
    this.searchProject();
    //查询项目下的所有实体
    this.searchProjectEquipmentInfoByProjectIdV2();
    //查询设备列表
    this.searchProjectTabList();
  },
  methods: {
    //查询数据点码表类型
    searchCodes(number, key) {
      let self = this;
      let params = { codesType: number };
      GROUPAPI.searchCodes(params).then(res => {
        if (res.data.code == 200) {
          this[key] = res.data.data;
        }
      });
    },
    //获取项目列表
    searchProject() {
      PROJECTAPI.searchProject().then(res => {
        if (res.data.code == 200) {
          this.projectOptions = res.data.data;
        }
      });
    },
    //查询项目下的所有实体
    searchProjectEquipmentInfoByProjectIdV2(){
      let params = {projectId:this.projectId}
      PROJECTAPI.searchProjectEquipmentInfoByProjectIdV2(params).then(res => {
        if (res.data.code == 200) {
          this.infoIdOptions = res.data.data;
        }
      });
    },
    //打开侧边栏展示
    openDrawer(flag, row) {
      this.currentRef = flag;
      if (flag == 'formTab') {
        if (!row) {
          this.drawerTitle = '添加主接线图页签';
          this.formTab = {};
        } else {
          this.drawerTitle = '修改主接线图页签';
          this.formTab = row;
        }
      }
      if (flag == 'formTemplate') {
        if (!row) {
          this.drawerTitle = '添加模板';
          this.formTemplate = {};
          //项目id
          this.formTemplate.projectId = this.projectId;
          //页签id
          this.formTemplate.tabId = this.currentSelectTab.id;
        } else {
          this.drawerTitle = '修改模板';
          this.formTemplate = row;
        }
      }
      if (flag == 'formDevice') {
        if (!row) {
          this.drawerTitle = '添加设备';
          this.formDevice = {nameType:'',positionType:''};
          this.formDevice.templateId = this.currentSelectTemplate.id;
        } else {
          this.drawerTitle = '修改设备';
          this.formDevice = row;
        }
      }
      if (flag == 'formData') {
        if (!row) {
          this.drawerTitle = '添加数据点';
          this.formData = {};
          this.formDevice.equipLogicId = this.currentSelectDevice.id;
        } else {
          this.drawerTitle = '修改数据点';
          this.formData = row;
          this.infoIdChildOptions = [{fieldsId:row.infoId,content:row.infoName}];
        }
      }
      //设置编辑标记
      this.currentEdit = flag;
      this.drawer = true;
    },
    //新增页签
    addProjectTab(flag) {
      let params = this.formTab;
      params.projectId = this.projectId;
      PROJECTAPI.addProjectTab(params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.searchProjectTabList();
            if (!flag) {
              this.drawer = false;
            } else {
              this.formTab = {};
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //修改页签
    updateProjectTab(flag) {
      let params = this.formTab;
      PROJECTAPI.updateProjectTab(params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.searchProjectTabList();
            this.drawer = false;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //查询页签
    searchProjectTabList() {
      let params = { entityId: this.projectId };
      PROJECTAPI.searchProjectTabList(params).then(res => {
        if (res.data.code == 200) {
          this.tableTabData = res.data.data;
        }
      });
    },
    //添加模板
    addProjectTemplateInfo() {
      let params = this.formTemplate;
      PROJECTAPI.addProjectTemplateInfo(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.loading = false;
          this.drawer = false;
          this.searchProjectTemplateInfoListByProjectIdAndTabID();
        }
      }).catch(error=>{
        this.loading = false;
      });
    },
    //修改模板
    updateProjectTemplateInfo() {
      let params = this.formTemplate;
      PROJECTAPI.updateProjectTemplateInfo(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.loading = false;
          this.drawer = false;
          this.searchProjectTemplateInfoListByProjectIdAndTabID();
        }
      }).catch(error=>{
        this.loading = false;
      });
    },
    //查询模板
    searchProjectTemplateInfoListByProjectIdAndTabID() {
      let params = { projectId: this.projectId, tabId: this.currentSelectTab.id };
      PROJECTAPI.searchProjectTemplateInfoListByProjectIdAndTabID(params).then(res => {
        if (res.data.code == 200) {
          this.tableTemplateData = res.data.data;
        }
      });
    },
    //添加设备
    addProjectEquipmentLogicList() {
      let params = this.formDevice;
      PROJECTAPI.addProjectEquipmentLogicList(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.loading = false;
          this.drawer = false;
          this.searchProjectEquipmentLogicListByTemplateId();
        }
      }).catch(error=>{
        this.loading = false;
      });
    },
    //修改设备
    updateProjectEquipmentLogicList() {
      let params = this.formDevice;
      PROJECTAPI.updateProjectEquipmentLogicList(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.loading = false;
          this.drawer = false;
          this.searchProjectEquipmentLogicListByTemplateId();
        }
      }).catch(error=>{
        this.loading = false;
      });
    },
    //查询设备
    searchProjectEquipmentLogicListByTemplateId() {
      let params = { templateId: this.currentSelectTemplate.id };
      PROJECTAPI.searchProjectEquipmentLogicListByTemplateId(params).then(res => {
        if (res.data.code == 200) {
          this.tableDeviceData = res.data.data;
          this.tableDeviceDataOptions = [{equipName:'根节点',id:0},...res.data.data];
        }
      })
    },
    //添加数据点
    addProjectEquipmentFieldsLogicList() {
      let params = this.formData;
      params.equipLogicId = this.currentSelectDevice.id;
      params.templateId = this.currentSelectTemplate.id;
      PROJECTAPI.addProjectEquipmentFieldsLogicList(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.loading = false;
          this.drawer = false;
          this.searchProjectEquipmentFieldsLogicListByEquipId();
        }
      }).catch(error=>{
        this.loading = false;
      });
    },
    //修改数据点
    updateProjectEquipmentFieldsLogicList() {
      let params = this.formData;
      params.templateId = this.currentSelectTemplate.id;
      PROJECTAPI.updateProjectEquipmentFieldsLogicList(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.loading = false;
          this.drawer = false;
          this.searchProjectEquipmentFieldsLogicListByEquipId();
        }
      }).catch(error=>{
        this.loading = false;
      });
    },
    //查询数据点
    searchProjectEquipmentFieldsLogicListByEquipId() {
      let params = { equipId: this.currentSelectDevice.id };
      PROJECTAPI.searchProjectEquipmentFieldsLogicListByEquipId(params).then(res => {
        if (res.data.code == 200) {
          this.tableDeviceDataPoint = res.data.data;
        }
      });
    },
    //查询数据点列表
    searchProjectEquipmentFieldsInfo() {
      let self = this;
      let params = { projectId: this.projectId,equipId:this.deviceModel };
      PROJECTAPI.searchProjectEquipmentFieldsInfo(params).then(res => {
        if (res.data.code == 200) {
          self.currentSelectData = '';
          self.infoIdChildOptions = res.data.data;
        }
      });
    },
    //仅保存-保存并继续
    onSave(flag) {
      let self = this;
      let ruleName = this.currentRef;
      this.$refs[ruleName].validate(valid => {
        if (valid) {
          this.loading = true;
          let has = false;
          switch (ruleName) {
            case 'formTab': {
              if (self.formTab.id) {
                self.updateProjectTab();
              } else {
                self.addProjectTab();
              }
              has = true;
              break;
            }
            case 'formTemplate': {
              if (self.formTemplate.id) {
                self.updateProjectTemplateInfo();
              } else {
                self.addProjectTemplateInfo();
              }
              has = true;
              break;
            }
            case 'formDevice': {
              if (self.formDevice.id) {
                self.updateProjectEquipmentLogicList();
              } else {
                self.addProjectEquipmentLogicList();
              }
              has = true;
              break;
            }
            case 'formData': {
              if (self.formData.id) {
                self.updateProjectEquipmentFieldsLogicList();
              } else {
                self.addProjectEquipmentFieldsLogicList();
              }
              has = true;
              break;
            }
          }
          if (!has) {
            this.loading = false;
            this.$message.warning('没有匹配的数据类型！');
          }
        } else {
          this.loading = false;
          return false;
        }
      });
    },
    //保存并继续
    onSaveAnd() {
      let self = this;
      let ruleName = this.currentRef;
      this.$refs[ruleName].validate(valid => {
        if (valid) {
          this.loading = true;
          // if (self.formTab.id) {
          //   self.updateProjectTab(true);
          // } else {
          // }
            self.addProjectTab(true);
        } else {
          return false;
        }
      });
    },
    //取消
    onCancel() {
      this.drawer = false;
      // this.onReset();
    },
    //重置
    onReset() {
      let ruleName = this.currentRef;
      this.$nextTick(function() {
        this.$refs[ruleName].resetFields();
      });
    },
    clickTabRow(row) {
      let self = this;
      this.$nextTick(function() {
        self.currentSelectTab = row;
        self.formTab = row;
        self.tableDeviceData = [];
        self.tableDeviceDataPoint = [];
        self.currentSelectTemplate = '';
        self.currentSelectDevice = '';
        self.currentSelectData = '';
        self.searchProjectTemplateInfoListByProjectIdAndTabID();
      });
    },
    clickTemplateRow(row) {
      let self = this;
      this.$nextTick(function() {
        self.currentSelectTemplate = row;
        self.formTemplate = row;
        self.tableDeviceDataPoint = [];
        self.currentSelectDevice = '';
        self.currentSelectData = '';
        self.searchProjectEquipmentLogicListByTemplateId();
      });
    },
    clickDeviceRow(row) {
      let self = this;
      this.$nextTick(function() {
        self.currentSelectDevice = row;
        self.formDevice = row;
        self.currentSelectData = '';
        self.searchProjectEquipmentFieldsLogicListByEquipId();
      });
    },
    clickDataPointRow(row) {
      let self = this;
      this.$nextTick(function() {
        self.currentSelectData = row;
        self.formData = row;
      });
    },
    handleClose(done) {
      done();
    },
    //清理接线图缓存
    clearCache(){
      let fid = '';
      let tid = '';
      if(this.currentSelectTemplate){
        fid = this.currentSelectTemplate.projectId;
        tid = this.currentSelectTemplate.tabId;
      }else{
        this.$message.error('请选择页签和模板！');
        return false;
      }
      let params = {projectId:fid,tabId:tid};
      PROJECTAPI.clearProjectWiringDiagramCache(params).then(res=>{
        if(res.data.code==200){
          this.$message.success('操作成功');
        }else{
          this.$message.success('操作失败');
        }
      })
    }
  }
};
</script>

<style lang="scss">
.first-allocation {
  overflow-y: auto;
  margin: 0px;
  padding: 0px;
  overflow-x: hidden;
  .el-table--medium td {
    padding: 0px !important;
  }
  .el-table--medium th {
    padding: 4px !important;
  }
  .custom-header{
      margin-top:10px;
    .el-card__header{
      padding:10px;
    }
    .el-card__body{
      padding:10px;
    }
  }
  .tbl {
    width: 100%;
  }
}
.form-drawer {
  .btn {
    width: 110px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/projecttemplateconfig.vue